import React from "react";
import Sidebar from "../admin/sidebar/Sidebar";
import Gallery from "../admin/addBlog/Gallery";
function AdminGalleryPage() {
  return (
    <div>
      <Sidebar/>
      <Gallery/>
    </div>
  );
}

export default AdminGalleryPage;
